import { Dispatch, SetStateAction } from 'react';
import { DialogInOne } from 'src/components';
import { Box, Typography } from 'src/components/MuiGenerals';
import { useTranslation } from 'src/hooks';

type Props = {
  isOpen: boolean;
  onConfirmClose: () => void;
  onClose: () => void;
};

const PreventCancelDialog = (props: Props) => {
  const { isOpen, onConfirmClose, onClose } = props;
  const { t } = useTranslation('clientCreditAllocation');
  return (
    <DialogInOne
      title={''}
      self={{
        open: isOpen,
        onClose: onClose,
      }}
      content={
        <Box>
          <Typography variant="h6" children={t('sureToCancelUpload')} />
        </Box>
      }
      onConfirm={onConfirmClose}
      onCancel={onClose}
    />
  );
};
export default PreventCancelDialog;
